module.exports = __webpack_public_path__ + "img/logo-white.e72a326f.png";